<template>
  <div class="plv-ia-checkin-ongoing">
    <div class="plv-ia-checkin-ongoing__body">
      <p class="plv-ia-checkin-ongoing-text">{{ t('plvIA.checkIn.currentlyPerson') }} <span class="pws-vclass-checkin-checkInNum">{{ checkInNum }}</span> {{ t('plvIA.checkIn.person') }}</p>
      <div class="plv-ia-checkin-ongoing-countdown pws-vclass-checkin-ongoing-countdown">
        <span>{{ remainingTime }}</span>
        <span>{{ t('plvIA.checkIn.secondsShorthand') }}</span>
      </div>
      <p class="plv-ia-checkin-ongoing-text">{{ checkInTips }}</p>
    </div>

    <div class="plv-ia-checkin-ongoing__footer">
      <button
        class="plv-ia-btn-new plv-ia-btn-orange pws-vclass-btn-orange"
        @click="stop"
      >
        {{ t('plvIA.checkIn.stopCheckIn') }}
      </button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';

export default {
  mixins: [Locale],
  props: {
    remainingTime: {
      type: Number,
      default: 0,
    },
    checkInNum: {
      type: Number,
      default: 0,
    },
    checkInTips: {
      type: String,
      default: '',
    },
  },

  methods: {
    stop() {
      this.$emit('stop');
    }
  }
};
</script>

<style lang="scss">
.plv-ia-checkin-ongoing {
  position: relative;
  height: 100%;
}
.plv-ia-checkin-ongoing__body {
  padding-top: 50px;
}

.plv-ia-checkin-ongoing-text {
  text-align: center;
  color: #606266;
  font-size: 14px;
}

.plv-ia-checkin-ongoing-countdown {
  margin: 20px auto;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border-radius: 60px;
  background-color: #E5F2FE;
  color: #2196F3;
  font-size: 0;

  span {
    font-size: 32px;
  }

  span + span {
    font-size: 14px;
    padding-left: 4px;
  }
}

.plv-ia-checkin-ongoing__footer {
  position: absolute;
  bottom: 24px;
  left: 0;
  width: 100%;
  text-align: center;
}

</style>
